import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateGetTariffs = {
  getTariffs: { data: null, loading: false, error: null },
};

export const getTariffs = createAsyncThunk(
  "tariff/getTariffs",
  async (data, { rejectWithValue, fulfillWithValue }) => {
    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/tariffs/get-tariffs/`, {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return fulfillWithValue(res.data);
      })
      .catch((res) => {
        console.log(res);
        return rejectWithValue(
          res.response?.data || { error: "Failed to fetch tariffs" }
        );
      });
  }
);

export const reducerGetTariffs = {
  [getTariffs.pending]: (state) => {
    state.getTariffs.loading = true;
    state.getTariffs.error = null;
  },
  [getTariffs.fulfilled]: (state, action) => {
    state.getTariffs.loading = false;
    state.getTariffs.data = action.payload;
    state.getTariffs.error = null;
  },
  [getTariffs.rejected]: (state, action) => {
    state.getTariffs.loading = false;
    state.getTariffs.error = action.payload;
  },
};
